<div class="populations-layout">
  <div class="title-bar title-bar--responsive populations-header">
    <div class="title-bar__heading populations-header__title">
      <h1>POPULATIONS</h1>
      <app-help screen="populations"></app-help>
    </div>
    <div class="title-bar__actions populations-header__actions">
      <button mat-flat-button color="primary" class="populations-header__button" (click)="createPopulation()">
        <mat-icon fontIcon="add" aria-hidden="true"></mat-icon>
        <span>New Population</span>
      </button>
      <app-aid-year [disabled]="false"></app-aid-year>
    </div>
  </div>

  <mat-card appearance="outlined">
    @if (cc.populations | async; as populations) {
      <div>
        @if (populations.length > 0) {
          <div class="populations-grid-wrapper" appKeyboardScrollable>
            <table class="table table-hover populations-grid">
              <thead>
                <tr>
                  <th scope="col">Name/Description</th>
                  <th scope="col">
                    Usage
                    <br />
                    <span class="legend-package">Package</span>
                    <span class="legend-cost">Cost</span>
                    <span class="legend-next-step">Next Step</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (pop of populations; track trackByPopulationId($index, pop)) {
                  <tr
                    class="populations-row"
                    (click)="openPopulation(pop)"
                    >
                    <th scope="row">
                      <a
                        class="link"
                        role="button"
                        tabindex="0"
                        (click)="activatePopulation($event, pop)"
                        (keydown.enter)="activatePopulation($event, pop)"
                        (keydown.space)="activatePopulation($event, pop)"
                        >
                        {{ pop.name }}
                      </a>
                      <div class="description" [innerHTML]="pop.description"></div>
                    </th>
                    <td>
                      <app-usage entityType="Population" [entityId]="pop.id"></app-usage>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="populations-empty">
            <mat-icon fontIcon="inbox" aria-hidden="true"></mat-icon>
            <p>There are no populations yet.</p>
            <button mat-stroked-button color="primary" (click)="createPopulation()">Add your first population</button>
          </div>
        }
      </div>
    }
  </mat-card>
</div>
